import React, { useEffect } from 'react';
import { Link as RouterLink, useHistory, useLocation } from 'react-router-dom';

import {
  Box,
  ButtonBase,
  Grid,
  Hidden,
  Link,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import CancelarPolizaIcon from '../../../assets/img/cancelarPoliza.svg';
import { ReactComponent as RightIcon } from '../../../assets/img/icon/Right.svg';
import MisDenunciasIcon from '../../../assets/img/misDenuncias.svg';
import MisPagosIcon from '../../../assets/img/misPagos.svg';
import ModificarMedioPagoIcon from '../../../assets/img/modificarMedioPago.svg';
import SuraCard from '../../../components/SuraCard';
import { useNavigationContext } from '../../../context/Navigation/navigation.provider';
import { useAuthDataContext } from '../../../context/auth/auth.provider';
import { dataLayerPush } from '../../../helpers/dataLayerPush';
import Navigation from './Navigation/Navigation.component';
import Profile from './Profile/Profile.component';

// import { useNavigationContext } from '@context/Navigation/navigation.provider';

const CARDS = [
  {
    link: '/cancel-policy',
    title: 'Cancelar póliza',
    content: 'Cancelá tus pólizas',
    image: CancelarPolizaIcon,
  },
];

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    label: {
      color: '#768692',
    },
    subLabel: {
      color: '#393B3D',
      fontWeight: 500,
    },
    contactBoxes: {
      marginRight: '70px',
      marginBottom: '12px',
    },
    suraCard: {
      display: 'grid',
      minHeight: '80px',
      [theme.breakpoints.up('sm')]: {
        minHeight: '100px',
      },
    },
    title: {
      color: '#000',
      fontWeight: 500,
      fontSize: '20px',
      marginBottom: '8px',
      [theme.breakpoints.down('xs')]: {
        fontSize: '16px',
      },
    },
    description: {
      color: '#768692',
      fontWeight: 400,
      fontSize: '16px',
    },
  })
);

const Account = (props) => {
  const { user } = useAuthDataContext();
  const { updateNavigation, resetNavigationAccount } = useNavigationContext();
  const classes = useStyle();

  const cardTag = (card) => {
    if (card.title === 'Cancelar póliza') {
      dataLayerPush('cuenta_cancelar_poliza', user?.id);
    } else if (card.title === 'Mis pagos') {
      dataLayerPush('cuenta_mis_pagos', user?.id);
    }
  };

  useEffect(() => {
    dataLayerPush('Cuenta', user?.id);
    resetNavigationAccount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePush = async (title, url) => {
    await updateNavigation({
      title,
      url,
    });
  };

  return (
    <>
      <Profile />

      <Grid container justify="center">
        <Grid item xs={11} sm={11}>
          <Box style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Box className={classes.contactBoxes}>
              <Typography variant="caption" className={classes.label}>
                DNI
              </Typography>
              <Typography className={classes.subLabel}>
                {user.identification_number}
              </Typography>
            </Box>
            <Box className={classes.contactBoxes}>
              <Typography variant="caption" className={classes.label}>
                TELÉFONO
              </Typography>
              <Typography className={classes.subLabel}>{user.phone}</Typography>
            </Box>
            <Box className={classes.contactBoxes}>
              <Typography variant="caption" className={classes.label}>
                EMAIL
              </Typography>
              <Typography className={classes.subLabel}>{user.email}</Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box my={3}>
        <Grid container justify="center">
          <Grid item xs={11}>
            <Grid container>
              {CARDS.map((card: any, index: number) => (
                <Grid item xs={12} sm={6} key={index.toString()}>
                  <Box my={3} mr={3} onClick={() => cardTag(card)}>
                    <ButtonBase
                      // component={RouterLink}
                      // to={card.link}
                      onClick={() => handlePush(card.title, card.link)}
                      style={{ width: '100%' }}
                    >
                      <SuraCard className={classes.suraCard}>
                        <Box
                          m={1}
                          marginLeft="16px"
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Box>
                              {/* <img src={card.image} alt={card.title}></img> */}
                            </Box>
                            <Box ml={3}>
                              <Typography className={classes.title}>
                                {card.title}
                              </Typography>
                              <Typography className={classes.description}>
                                {card.content}
                              </Typography>
                            </Box>
                          </Box>
                          <Box>
                            <RightIcon></RightIcon>
                          </Box>
                        </Box>
                      </SuraCard>
                    </ButtonBase>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
export default Account;
